import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasProgramTemplateSchema = withDefaults({
  type: 'tas-program-template',
  objectExtensions: ['tas-program-template'],
  fields: [
    {
      kind: 'attribute',
      name: 'code',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'fields',
    },
    {
      kind: 'attribute',
      name: 'customFields',
    },
    {
      kind: 'attribute',
      name: 'faqs',
    },
    {
      kind: 'attribute',
      name: 'approverInstructions',
    },
    {
      kind: 'attribute',
      name: 'isTrial',
    },
    {
      kind: 'attribute',
      name: 'eligibilityExpression',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'compositePolicyMd',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'tasProgramTemplates',
      },
    },
    {
      kind: 'hasMany',
      name: 'conditions',
      type: 'condition',
      options: {
        async: false,
        inverse: 'conditionable',
        as: 'conditionable',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasProgramInstances',
      type: 'tas-program-instance',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasFieldOptions',
      type: 'tas-field-option',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasGroups',
      type: 'tas-group',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasGroupings',
      type: 'tas-grouping',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
      },
    },
    {
      kind: 'hasMany',
      name: 'versions',
      type: 'tas-program-template-version',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasEligibilities',
      type: 'tas-eligibility',
      options: {
        async: false,
        inverse: 'tasProgramTemplate',
      },
    },
  ],
});

export default TasProgramTemplateSchema;
